import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIState } from './ui.state';
import { CoreState } from '../core.state';

const selectCoreState = createFeatureSelector('core');

export const selectUIState = createSelector(selectCoreState, (coreState: CoreState) => coreState.uiState);

export const selectUILanguageList = createSelector(selectUIState, (state: UIState) => state.languageList);
